export default [
    {
        sortable: false,
        text: "Ponderable",
        value: "ponderable"
    },
    {
        sortable: false,
        text: "PlataformaId",
        value: "plataformaId"
    },
    {
        sortable: false,
        text: "Libre",
        value: "libre",
        searchType: "boolean"
    },
    {
        sortable: false,
        text: "Asignatura ID",
        value: "asignaturaId"
    },
    {
        sortable: false,
        text: "Tipo Instrumento ID",
        value: "tipoInstrumentoId"
    },
    {
        sortable: false,
        text: "Campo origen",
        value: "campoOrigen"
    },
    {
        sortable: false,
        text: "Orden",
        value: "orden"
    },
    {
        sortable: false,
        text: "Tooltip",
        value: "tooltip"
    },
    {
        sortable: false,
        text: "Valor mínimo",
        value: "valorMinimo"
    },

    {
        sortable: false,
        text: "Valor máximo",
        value: "valorMaximo"
    },
    {
        sortable: false,
        text: "Color",
        value: "color"
    },

    { text: "Acciones", value: "action", sortable: false }
]
